import _toConsumableArray from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { illegalArity } from "@thi.ng/errors";
export function comp() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  var a = fns[0],
      b = fns[1],
      c = fns[2],
      d = fns[3],
      e = fns[4],
      f = fns[5],
      g = fns[6],
      h = fns[7],
      i = fns[8],
      j = fns[9];

  switch (fns.length) {
    case 0:
      illegalArity(0);

    case 1:
      return a;

    case 2:
      return function () {
        return a(b.apply(void 0, arguments));
      };

    case 3:
      return function () {
        return a(b(c.apply(void 0, arguments)));
      };

    case 4:
      return function () {
        return a(b(c(d.apply(void 0, arguments))));
      };

    case 5:
      return function () {
        return a(b(c(d(e.apply(void 0, arguments)))));
      };

    case 6:
      return function () {
        return a(b(c(d(e(f.apply(void 0, arguments))))));
      };

    case 7:
      return function () {
        return a(b(c(d(e(f(g.apply(void 0, arguments)))))));
      };

    case 8:
      return function () {
        return a(b(c(d(e(f(g(h.apply(void 0, arguments))))))));
      };

    case 9:
      return function () {
        return a(b(c(d(e(f(g(h(i.apply(void 0, arguments)))))))));
      };

    case 10:
    default:
      var fn = function fn() {
        return a(b(c(d(e(f(g(h(i(j.apply(void 0, arguments))))))))));
      };

      return fns.length === 10 ? fn : comp.apply(void 0, [fn].concat(_toConsumableArray(fns.slice(10))));
  }
}
export function compL() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return comp.apply(null, fns.reverse());
}
/**
 * @deprecated renamed to {@link (compL:1)}
 */

export var compI = compL;